export * from "./TruckLocationModel";
